import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader';
import Biomarkers from '../Components/Biomarkers/Biomarkers';

export default function BiomarkersPage() {
  return (
    <>
      <Helmet>
        <title>DISGENET: Biomarkers</title>
        <meta name="description" content="Explore biomarkers in DISGENET." />
      </Helmet>
      <CommonHeader />
      <Biomarkers />
    </>
  );
}
